import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, TextField, Button, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import MobilePanelConfigurationQuery from '../../services/query/mobileAppConfiguration/MobileAppConfiguration.services';
import MobilePanelConfigurationCommand from '../../services/command/mobilepanelconfiguration/MobilePanelConfigurationCommand.services';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SCUIMPConfigDialogV2 } from '../../atomic/molecules/SCUIMPConfigDialogV2/SCUIMPConfigDialogV2';
import Tooltip from '@mui/material/Tooltip';
import { CacheCommand } from '../../services/command';
import { MPCV2, mpcv2Cls } from './mpConfigV2.classes';

export const MpConfigV2: FC<any> = () => {
    const { t } = useTranslation();
    const [refresh, setRefresh] = useState(false);
    const [searchedMpConfigList, setSearchedMpConfigList] = useState<any>();
    const [openEditModal, setOpenEditModal] = useState(false);
    const onModalEditClose = () => setOpenEditModal(false);
    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);
    const onModalEditOpen = () => setOpenEditModal(true);
    const [searchedMpConfigName, setSearchedMpConfigName] = useState('');
    const [mobilepanelconfiguration, setMobilePanelConfiguration] = useState([]);
    const [mpConfiguration, setMpConfiguration] = useState<any>();
    const region = useSelector((state: any) => state.lastRegionReducer.setLastRegion);

    const getMobilePanelConfiguration = () => {
        MobilePanelConfigurationQuery.ListMobileAppConfigurationV2(region)
            .then((res: any) => {
                if (res) {
                    let parseData = res.model.data.map((item: any) => {
                        return {
                            id: item.id || '-',
                            parameter_key: item.parameter_Key || ' ',
                            parameter_value: item.parameter_Value || ' ',
                        };
                    });

                    setMobilePanelConfiguration(parseData);
                    setSearchedMpConfigList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const requestSearchMpConfig = (searchedVal: any) => {
        setSearchedMpConfigName(searchedVal.target.value);
        let filteredRoles = searchedMpConfigList.filter(
            (o: any) => o.parameter_key.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setMobilePanelConfiguration(filteredRoles);
    };

    useEffect(() => {
        getMobilePanelConfiguration();
    }, [region, refresh]);
    const DeleteMobilPanelConfigurationCache = () => {
        let req = {};
        CacheCommand.DeleteMobilPanelConfigurationCache(req).then((res: any) => {
            if (res) {
                Swal.fire('Success', 'Başarılı', 'success');
                return;
            } else {
                Swal.fire('Error', 'Error', 'error');
                return;
            }
        });
    };
    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobilePanel.deleteConfig'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await MobilePanelConfigurationCommand.PostRemoveMobilePanelConfiguration(params);
            await Swal.fire('Silindi!', ' ', 'success');
            refreshFunc();
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'parameter_key',
            headerName: 'Key',
            width: 150,
            flex: 1,
        },
        {
            field: 'parameter_value',
            headerName: 'Value',
            width: 160,
            flex: 1,
        },
        {
            field: 'düzenlee',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setMpConfiguration(params.row);
                    onModalEditOpen();
                };

                return (
                    <div className={MPCV2.datagridEditCell}>
                        <Button className={MPCV2.inputButtonRowEdit} onClick={onclick}>
                            <EditIcon />
                        </Button>
                    </div>
                );
            },
        },

        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    sil(params.id);
                };
                return (
                    <div className={MPCV2.datagridDeleteCell}>
                        <Button className={MPCV2.inputButtonRowDelete} onClick={onclick}>
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];

    return (
        <SCUIContent>
            <SCUIMPConfigDialogV2
                selectedRow={mpConfiguration}
                open={openEditModal}
                onClose={onModalEditClose}
                refresh={refreshFunc}
            />
            <Grid className={MPCV2.page} container direction="row">
                <Grid
                    className={MPCV2.titleSection}
                    size={{
                        lg: 8,
                        md: 8,
                        xs: 8,
                    }}
                >
                    <h1 className={mpcv2Cls('headtxt', MPCV2.pageTitle)}>{t('mobilePanel.mobilePanelConfiguration')}</h1>
                </Grid>
                <Grid
                    className={MPCV2.cacheToolbarSection}
                    sx={{ display: 'flex', justifyContent: 'flex-end', mr: 1 }}
                    size={{
                        lg: 2,
                        md: 2,
                        xs: 2,
                    }}
                >
                    <Tooltip title={t('mobilePanel.clearMobilePanelCache')}>
                        <Button
                            className={MPCV2.inputButtonClearMobilePanelCache}
                            variant="text"
                            color="secondary"
                            startIcon={<DeleteIcon style={{ color: 'red' }} />}
                            onClick={() => {
                                DeleteMobilPanelConfigurationCache();
                            }}
                        ></Button>
                    </Tooltip>
                </Grid>
                <Grid
                    className={MPCV2.actionsSection}
                    size={{
                        lg: 1,
                        md: 1,
                        xs: 1,
                    }}
                >
                    <SCUIButton
                        className={MPCV2.inputButtonAddConfig}
                        text={t('mobilePanel.addConfig')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => {
                            setMpConfiguration([]);
                            onModalEditOpen();
                        }}
                    />
                </Grid>
                <Grid
                    className={MPCV2.filterSection}
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        className={MPCV2.inputTextSearchKey}
                        label={'Key'}
                        value={searchedMpConfigName}
                        onChange={(searchVal) => requestSearchMpConfig(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    className={MPCV2.gridSection}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Box className={MPCV2.gridWrap}>
                        <SCUICustomDataGrid
                            rows={mobilepanelconfiguration}
                            columns={columns}
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        {
                                            field: 'id',
                                            sort: 'asc',
                                        },
                                    ],
                                },
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
